var o2 = "/static/e13e3514112e77e6.png";

export { o2 as default };
//# sourceMappingURL=o_2.png.js.map
